import request from "@/utils/request";

export function getSchedule(payload) {
  return request.post(`/hcp/teacherSpace/zj/schedule`, {
    ...payload
  });
}

export function getWaitLessonPage(payload) {
  return request.post(`/hcp/teacherSpace/zj/myCourses`, {
    ...payload
  });
}



// WEBPACK FOOTER //
// ./src/services/chineseTeacher1v1.js